<ng-container *ngIf="component.data$ | async as data">
  <a class="sd-button" href="{{ data.link.url }}" sdButton processLinks>{{ data.label }}</a>
</ng-container>
